import { Component } from "react"
import { func } from "prop-types"
import noop from "lodash/noop"

export default class GlobalMouseHandle extends Component {
  static propTypes = {
    onClick: func,
    onDblClick: func,
    onMouseDown: func,
    onMouseMove: func,
    onMouseOut: func,
    onMouseOver: func,
    onMouseUp: func,
    onWheel: func,
  }

  static defaultProps = {
    onClick: noop,
    onDblClick: noop,
    onMouseDown: noop,
    onMouseMove: noop,
    onMouseOut: noop,
    onMouseOver: noop,
    onMouseUp: noop,
    onWheel: noop,
  }

  componentDidMount() {
    document.addEventListener(`click`, this.handleClick)
    document.addEventListener(`dblclick`, this.handleDblClick)
    document.addEventListener(`mousedown`, this.handleMouseDown)
    document.addEventListener(`mousemove`, this.handleMouseMove)
    document.addEventListener(`mouseout`, this.handleMouseOut)
    document.addEventListener(`mouseover`, this.handleMouseOver)
    document.addEventListener(`mouseup`, this.handleMouseUp)
    document.addEventListener(`wheel`, this.handleWheel)
  }

  componentWillUnmount() {
    document.removeEventListener(`click`, this.handleClick)
    document.removeEventListener(`dblclick`, this.handleDblClick)
    document.removeEventListener(`mousedown`, this.handleMouseDown)
    document.removeEventListener(`mousemove`, this.handleMouseMove)
    document.removeEventListener(`mouseout`, this.handleMouseOut)
    document.removeEventListener(`mouseover`, this.handleMouseOver)
    document.removeEventListener(`mouseup`, this.handleMouseUp)
    document.removeEventListener(`wheel`, this.handleWheel)
  }

  /* eslint-disable react/destructuring-assignment */

  handleClick = e => this.props.onClick(e)

  handleDblClick = e => this.props.onDblClick(e)

  handleMouseDown = e => this.props.onMouseDown(e)

  handleMouseMove = e => this.props.onMouseMove(e)

  handleMouseOut = e => this.props.onMouseOut(e)

  handleMouseOver = e => this.props.onMouseOver(e)

  handleMouseUp = e => this.props.onMouseUp(e)

  handleWheel = e => this.props.onWheel(e)

  /* eslint-enable react/destructuring-assignment */

  render() {
    return null
  }
}
